// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__A0b97","multiSelect":"select_multiSelect__94UBM","popup":"select_popup__A3pQl","multiSelectPopup":"select_multiSelectPopup__qwmll"};